import styled from '@emotion/styled'

export const GridStyled = styled.div`
  .pf-l-grid {
    grid-gap: var(--margin) !important;
  }
`
